var React = require('react');

function ArrowCta (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"stroke":"#FE3C72","strokeLinecap":"square","strokeWidth":"2","d":"M13.867 2.133l3.86 3.86-3.86 3.862","key":0}),React.createElement("path",{"fill":"#FE3C72","d":"M0 5h18v2H0z","key":1})]));
}

ArrowCta.defaultProps = {"width":"20px","height":"12px","viewBox":"0 0 20 12"};

module.exports = ArrowCta;

ArrowCta.default = ArrowCta;
